// extracted by mini-css-extract-plugin
module.exports = {"gridPaddingLeft":"BOPPolicyChange_gridPaddingLeft__2dAyc","checkBoxLabel":"BOPPolicyChange_checkBoxLabel__S3DuY","checkBoxChange":"BOPPolicyChange_checkBoxChange__3Nbcq"};